import { Info, Layers, Settings } from "@mui/icons-material";
import { Button, DrawerProps, styled } from "@mui/material";

import { InlineDrawer } from "../drawers/InlineDrawer";
import { NavLink } from "./NavLink";

interface Props extends DrawerProps {
  config: string;
}

export function Navigation(props: Props) {
  const { config, ...drawerProps } = props;
  return (
    <NavigationDrawer
      variant="permanent"
      open={true}
      elevation={0}
      {...drawerProps}
    >
      <Button to={`/${config}/app/layers`} component={NavLink} variant="square">
        <Layers />
      </Button>
      <Button
        to={`/${config}/app/settings`}
        component={NavLink}
        variant="square"
        className="push-bottom"
      >
        <Settings />
      </Button>
      <Button
        to={`/${config}/app/information`}
        component={NavLink}
        variant="square"
      >
        <Info />
      </Button>
    </NavigationDrawer>
  );
}

const NavigationDrawer = styled(InlineDrawer)`
  .MuiPaper-root {
    background-color: ${({ theme }) => theme.palette.background.default};
    border-right: 0;

    display: flex;
    flex-direction: column;
    align-items: stretch;

    .push-bottom {
      margin-top: auto;
    }
  }
`;
